import React, { useContext } from 'react'
import { Editor, RichUtils } from 'draft-js'
import { EditorContext } from '.'
import injectSheet from 'react-jss'
import styles from './editor.styles'
import classNames from 'classnames'

const PobbleEditor = ({ classes, className, error, ...props }) => {
  const { editorState, onChange } = useContext(EditorContext)
  const handleKeyCommand = (command, editorState) => {
    const newState = RichUtils.handleKeyCommand(editorState, command)
    if (newState) {
      onChange(newState)
      return 'handled'
    }
    return 'not-handled'
  }
  return (
    <div
      className={classNames(
        classes.container,
        { [classes.error]: error },
        className
      )}>
      <Editor
        stripPastedStyles={true}
        handleKeyCommand={handleKeyCommand}
        editorState={editorState}
        onChange={onChange}
        {...props}
      />
    </div>
  )
}

export default injectSheet(styles)(PobbleEditor)
